import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, ShieldCheck } from "lucide-react";

/**
 * Cartel permanente del modo de facturación. En modo pruebas TODO CFDI emitido
 * es demo y no tiene validez fiscal — el usuario tiene que verlo siempre.
 */
export const PacModeBanner = () => {
  const [mode, setMode] = useState(null);

  useEffect(() => {
    api.get("/ops/fiscal/pac-mode").then(r => setMode(r.data)).catch(() => setMode(null));
  }, []);

  if (!mode) return null;

  if (mode.demo) {
    return (
      <div
        data-testid="pac-mode-banner-demo"
        className="border-2 border-amber-400 bg-amber-50 rounded-xl px-4 py-3 flex items-start gap-3"
      >
        <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-bold text-amber-900 uppercase tracking-wide">
            Modo pruebas — los CFDI emitidos NO tienen validez fiscal
          </p>
          <p className="text-xs text-amber-800 mt-1">
            Se timbran con un PAC simulado, quedan marcados como <strong>DEMO</strong> y no entran
            en DIOT, IVA mensual ni balanza. Para emitir facturas reales, Dirección debe activar el
            flag <code className="bg-amber-100 px-1 rounded">facturacion_pac_real</code> con las
            credenciales del PAC cargadas.
          </p>
        </div>
      </div>
    );
  }

  if (!mode.ready) {
    return (
      <div
        data-testid="pac-mode-banner-misconfigured"
        className="border-2 border-red-400 bg-red-50 rounded-xl px-4 py-3 flex items-start gap-3"
      >
        <AlertTriangle className="w-5 h-5 text-red-600 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-bold text-red-900">PAC real habilitado pero mal configurado</p>
          <p className="text-xs text-red-800 mt-1">
            Falta: {(mode.missing_credentials || []).join(", ") || "configuración del proveedor"}.
            No se puede emitir ninguna factura hasta resolverlo.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="pac-mode-banner-real"
      className="border border-emerald-300 bg-emerald-50 rounded-xl px-4 py-2.5 flex items-center gap-2"
    >
      <ShieldCheck className="w-4 h-4 text-emerald-600 shrink-0" />
      <p className="text-xs text-emerald-800">
        Timbrado <strong>real</strong> ante el SAT vía {mode.provider}. Cada CFDI emitido tiene
        validez fiscal.
      </p>
    </div>
  );
};
